import React from "react"
import Grid from "@material-ui/core/Grid"
import {paths} from "../../../actions/actionCreators"
import leaderboardImg from "./leaderboard.png"
import PrizesImg from "./award.png"
import backImg from "./back.png"
import rulesImg from "./rule.png"
import {withRouter} from "react-router-dom"
import {store} from "../../../store"
import {push} from "connected-react-router"

const NavigationButtons = (props) => {
	const navigate = (path) => store.dispatch(push(path))

	return (
		<Grid container justifyContent={"center"}>
			<Grid xs={6} hidden={props.location.pathname === paths.gameLeaderboard}>
				<div>
					<img
						onClick={() => navigate(paths.gameLeaderboard)}
						style={{width: "100%", cursor: "pointer"}}
						alt='leaderboard'
						src={leaderboardImg}
					/>
				</div>
			</Grid>
			<Grid xs={6} hidden={props.location.pathname === paths.gameRules}>
				<div>
					<img
						onClick={() => navigate(paths.gameRules)}
						style={{width: "100%", cursor: "pointer"}}
						alt='leaderboard'
						src={rulesImg}
					/>
				</div>
			</Grid>
			<Grid xs={6} hidden={props.location.pathname === paths.gamePrizes}>
				<div>
					<img
						onClick={() => navigate(paths.gamePrizes)}
						style={{width: "100%", cursor: "pointer"}}
						alt='prizes'
						src={PrizesImg}
					/>
				</div>
			</Grid>
			<Grid xs={12}>
				<div>
					<img
						onClick={() => navigate(paths.game)}
						style={{width: "100%", cursor: "pointer"}}
						alt='prizes'
						src={backImg}
					/>
				</div>
			</Grid>
		</Grid>
	)
}
export default withRouter(NavigationButtons)
